import { useEffect } from "react"
import { useDrawing } from "hooks/api/drawings/drawings.hook"
import { useCurrentUserStore } from "store/user.store"
import { useQuotationOwnerStore } from "store/quotationOwner.store"
import { resolveOwnerLabel } from "helpers/drawingAccess.helper"

// Publishes the editor's owner label (REQ-392) from the drawing query the file drawer already
// cached. Cleared on unmount so a later drawing never shows a stale owner.
export const useSyncQuotationOwnerLabel = (drawingId: number | null) => {
	const { data: drawing } = useDrawing(drawingId || null)
	const role = useCurrentUserStore((state) => state.currentUser.role)
	const setOwnerLabel = useQuotationOwnerStore((state) => state.setOwnerLabel)
	const ownerLabel = resolveOwnerLabel(role, drawing)

	useEffect(() => {
		setOwnerLabel(ownerLabel)
	}, [ownerLabel, setOwnerLabel])

	useEffect(() => () => setOwnerLabel(null), [setOwnerLabel])
}
